import * as React from "react";
import cs from "classnames";
import i18n from "i18next";

type InvertControlProps = {
  inverted: boolean;
  onClick: (e: React.SyntheticEvent) => void;
};

function InvertControl({ inverted, onClick }: InvertControlProps) {
  return (
    <li className={cs("nav-item", { active: inverted })} title={i18n.t("global.invertContrast")}>
      <button className="nav-link fa fa-lg fa-dot-circle-o unstyled-button" onClick={onClick} />
    </li>
  );
}

export default InvertControl;
